/// <amd-module name="Test/TestPlansHubRefresh/TestPlanClonePanel/Redux/TestPlanClonePanelReducer" />
import { default as produce } from "immer";
import { ITestPlanClonePanelState } from "./TestPlanClonePanelContracts";
import { TestPlanClonePanelActions, TestPlanClonePanelActionsTypes } from "./TestPlanClonePanelActions";

/**
 * TestPlanClonePanelReducer: Reducer for test plan clone panel.
 */
export function TestPlanClonePanelReducer(state: ITestPlanClonePanelState, action: TestPlanClonePanelActions): ITestPlanClonePanelState {
    state = state || ({} as ITestPlanClonePanelState);

    return produce(state, (draftState: ITestPlanClonePanelState) => {
        switch (action.type) {
            case TestPlanClonePanelActionsTypes.getRootNodesSucceeded:
                draftState.areaPathNode = action.payload.areaPathNode;
                draftState.iterationNode = action.payload.iterationNode;
                break;
            case TestPlanClonePanelActionsTypes.copyTestPlanInProgress:
                draftState.cloneInProgress = true;
                break;
            case TestPlanClonePanelActionsTypes.copyTestPlanSucceded:
                draftState.opId = action.payload.opId;
                draftState.newPlanId = action.payload.newPlanId;
                draftState.cloneInProgress = false;
                break;
            case TestPlanClonePanelActionsTypes.copyTestPlanFailed:
                draftState.cloneInProgress = false;
                break;
            case TestPlanClonePanelActionsTypes.loadModulesSucceeded:
                draftState.modulesLoaded = true;
                break;
            case TestPlanClonePanelActionsTypes.mandatoryFieldUpdated:
                draftState.mandatoryFieldUpdated = action.payload;
                break;
            default:
                break;
        }
    });
}
